import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thumbnail-placeholder',
  templateUrl: './thumbnail-placeholder.component.html',
  styleUrls: ['./thumbnail-placeholder.component.scss']
})
export class ThumbnailPlaceholderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
